export const HOW_SELL_CONST = {
    ACOPIO: 1,
    PRODUCCION_PROPIA: 2,
    CONSIGNACION: 3,
    COOPERATIVA: 4,
}

//How he sells (¿Cómo vende?)
export const howSell = {
    '-1': '--',
    0: '--',
    1: 'Acopio',
    2: 'Produccion Propia',
    3: 'Consignacion',
    4: 'Cooperativa',
}